// extracted by mini-css-extract-plugin
export default {"sectionSpecificProduct":"SectionSpecificProduct_sectionSpecificProduct__JF6Ar"};